<template>
  <div>
    <!-- Desktop Menu -->
    <v-app-bar app class="orange accent-3"  style="z-index: 300;">
      <v-app-bar-nav-icon @click.stop="sideNav = !sideNav" class="hidden-md-and-up" dark></v-app-bar-nav-icon>
      <v-icon dark>mdi-bus</v-icon>
      <v-toolbar-title>
        <span class="white--text">Delivery Kiosk <span class="caption">{{ versionWeb }}</span></span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only hidden-sm-only">
        <v-menu open-on-hover offset-y bottom v-for="item in menuItem" :key="item.key || item.title">
          <template v-slot:activator="{ on }">
            <!-- disabled marks a page still in testing: listed so it is no
                 surprise later, but not openable by this role. A group button
                 has no route of its own, so input-value lights it up while one
                 of its pages is open. -->
            <v-btn text v-on="on" dark :to="getRoute(item)" :disabled="item.disabled"
              :input-value="item.items ? isGroupActive(item) : undefined" :aria-label="item.label || item.title" class="no-uppercase">
              <v-icon>{{item.icon}}</v-icon>
              <v-badge :value="badgeFor(item) > 0" :content="badgeFor(item)" color="red" inline>
                {{item.title}}
              </v-badge>
            </v-btn>
          </template>
          <v-list v-if="item.items">
            <v-subheader v-if="item.subheader">{{ item.subheader }}</v-subheader>
            <v-list-item
              v-for="(subItem, index) in item.items" 
              :key="index" 
              :disabled="subItem.disabled"
              @click="handleMenuItemClick(subItem)"
            >
              <v-list-item-icon v-if="subItem.icon" class="mr-3">
                <v-icon>{{ subItem.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title :class="getMenuItemClass(subItem)">
                {{ subItem.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>

    <!-- Mobile Menu -->
    <v-navigation-drawer temporary v-model="sideNav" dark absolute color="orange accent-3" style="position:fixed; top:0; left:0;z-index: 300;">
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-account-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{userName}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="white"></v-divider>

      <v-list dense nav>
        <v-list-item 
          v-for="item in navItem"
          :key="item.title"
          :to="getRoute(item)"
          :disabled="item.disabled"
          color="white"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge :value="badgeFor(item) > 0" :content="badgeFor(item)" color="red" inline>
                {{ item.title }}
              </v-badge>
            </v-list-item-title>
            <v-list-item-subtitle v-if="item.disabled" class="caption white--text">
              อยู่ระหว่างทดสอบ
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider class="white"></v-divider>
      <v-list dense nav>
        <v-list-item
          v-for="item in connectionItems"
          :key="item.api"
          @click="handleMenuItemClick(item)"
        >
          <v-list-item-icon>
            <v-icon>mdi-connection</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="getMenuItemClass(item)">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list-item v-if="canChangePassword" @click="changePasswordOpen = true">
        <v-list-item-icon>
          <v-icon>mdi-lock-reset</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>เปลี่ยนรหัสผ่าน</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="logout">
        <v-list-item-icon>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>ออกจากระบบ</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-layout>
            <v-flex text-right>
              <span class="caption white--text">{{ versionWeb }}</span>
            </v-flex>
          </v-layout>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>
    <changePasswordDialog v-model="changePasswordOpen" @changed="passwordChanged"></changePasswordDialog>
    <br><br><br>
  </div>
</template>

<script>
import VueRouter from 'vue-router'
import { auth } from '@/firebase'
// The pages each role is offered, shared with the home launcher and the router
// guard so a page shown disabled here is a page the router actually refuses.
import MR from '@/components/menuRoutes'
import changePasswordDialog from '@/components/changePasswordDialog'

// Pages the app bar folds into one dropdown each, listed in the order the
// dropdown shows them. The fleet pages follow a delivery day: plan, confirm on
// คิวรถเล็ก, adjust, then look back. Eleven buttons ran off a laptop screen.
const MENU_GROUPS = [
  {
    key: 'fleetGroup', title: 'การจัดการรถ', icon: 'mdi-truck-delivery',
    members: ['dispatchPlan', 'upcountry', 'carBooking', 'managecar', 'carSchedule', 'managecarinfo']
  },
  {
    key: 'adminGroup', title: 'ผู้ดูแลระบบ', icon: 'mdi-shield-account',
    members: ['psn', 'drivers']
  }
]

export default {
  components: {
    changePasswordDialog
  },
  data() {
    return {
      versionWeb: 'v.1.55.1',
      sideNav: false,
      menuItem: [],
      navItem: [],
      changePasswordOpen: false,
    }
  },
  computed: {
    // A driver has a PIN, not a password. Drivers do not normally see this menu
    // at all (the driver screens draw driverBar instead), so this guards the
    // one way they could: a driver session opening a staff page by URL.
    canChangePassword() {
      return !!this.userRole && this.userRole !== 'driver'
    },
    // App.vue commits the email to state.user and the claim to state.status, both
    // plain strings -- the old `state.user.email` / `state.user.role` read
    // undefined off a string and only worked by falling through to
    // sessionStorage. sessionStorage stays as the fallback for a hard reload,
    // where it is populated before onAuthStateChanged has resolved. index.vue
    // resolves the role the same way, so the launcher and the menu agree.
    user() {
      return this.$store.state.user || sessionStorage.user
    },
    // The signed-in person as a name once the directory has it; the email until
    // then, or for an account nobody has named.
    userName() {
      return this.$personName(this.user)
    },
    userRole() {
      return this.$store.state.status || sessionStorage.status
    },
    proposalBadge () {
      return this.$store.getters.proposalBadge
    },
    // Single source for the connection entries, shared by the app bar and the drawer.
    // Connection 3 is offered only when the page is served from inside the office --
    // its path is root-relative and would not resolve anywhere else.
    connectionItems() {
      const items = [
        { title: 'Connection 1 (AIS)', icon: 'mdi-connection', api: 'api1' },
        { title: 'Connection 2 (TOT)', icon: 'mdi-connection', api: 'api2' }
      ]
      if (this.$store.getters.isLocalServer) {
        items.push({ title: 'Connection 3 (Local)', icon: 'mdi-connection', api: 'api3' })
      }
      return items
    }
  },
  methods: {
    // Propose and confirm: requests waiting on this user, on จองวันส่งสินค้า only.
    badgeFor (item) {
      return item && item.routeName === 'bookingDate' ? this.proposalBadge : 0
    },
    getRoute(item) {
      // Handle both route name and path navigation
      if (item.routeName) {
        return { name: item.routeName }
      }
      return item.link
    },
    
    menuRole() {
      const pages = MR.pagesForRole(this.userRole)

      // An unknown role gets no pages at all -- that is the bounce to login, and
      // it now covers only genuinely unknown roles. `manager` used to land here
      // because menuRole() had no branch for it, while router.js had been
      // authorizing it for จัดรถ, ตารางรถ and จัดรถอัตโนมัติ the whole time.
      if (!pages.length) {
        this.menuItem = []
        this.navItem = []
        this.$router.push('/').catch(() => {})
        return
      }

      // A page still in testing stays listed, disabled, so a shop sees it coming
      // rather than finding it one morning. router.js refuses the route as well.
      const pageItems = pages.map(page => ({
        title: page.title,
        icon: page.icon,
        routeName: page.routeName,
        disabled: !MR.canOpen(page, this.userRole)
      }))

      // The app bar only: the fleet and admin pages each share one dropdown, and the account
      // button is its icon alone with the email inside -- ten named pages plus an
      // email pushed the account menu, and with it ออกจากระบบ, off a laptop screen.
      // The drawer and the home cards still list every page on its own.
      this.menuItem = this.groupPages(pageItems).concat([{
        key: 'account',
        title: '',
        label: this.userName,
        subheader: this.userName,
        icon: 'mdi-account-circle',
        items: this.connectionItems
          .concat(this.canChangePassword ? [{ title: 'เปลี่ยนรหัสผ่าน', icon: 'mdi-lock-reset', action: 'changePassword' }] : [])
          .concat([{ title: 'ออกจากระบบ', icon: 'mdi-logout', action: 'logout' }])
      }])

      this.navItem = pageItems
    },
    
    // Collapses each MENU_GROUPS entry into one button, placed where the first
    // of its pages stood. A role offered fewer than two of a group's pages keeps
    // them as ordinary buttons -- a shop's คิวรถเล็ก stays a button of its own.
    groupPages(pageItems) {
      let out = pageItems
      MENU_GROUPS.forEach(def => {
        const members = def.members
          .map(name => out.find(item => item.routeName === name))
          .filter(Boolean)
        if (members.length < 2) return
        const group = {
          key: def.key,
          title: def.title,
          icon: def.icon,
          items: members.map(item => ({ title: item.title, icon: item.icon, routeName: item.routeName, disabled: item.disabled }))
        }
        const first = out.find(item => members.indexOf(item) !== -1)
        const next = []
        out.forEach(item => {
          if (item === first) next.push(group)
          else if (members.indexOf(item) === -1) next.push(item)
        })
        out = next
      })
      return out
    },

    isGroupActive(item) {
      return !!item.items && item.items.some(sub => sub.routeName && sub.routeName === this.$route.name)
    },

    handleMenuItemClick(item) {
      if (item.action === 'logout') {
        this.logout()
      }
      else if (item.action === 'changePassword') {
        this.changePasswordOpen = true
      }
      else if (item.routeName) {
        this.$router.push({ name: item.routeName }).catch(err => {
          // A navigation failure is the router doing its job -- the page is
          // already open, or router.beforeEach redirected or stopped the
          // navigation. Anything else (typically a page chunk that failed to
          // download) left the user where they were with nothing on screen,
          // so it is said out loud rather than logged to a console nobody in
          // production reads -- and which the production lint refuses.
          if (VueRouter.isNavigationFailure(err)) return
          this.$root.$message('เปิดหน้าไม่สำเร็จ',
            'กรุณาตรวจสอบการเชื่อมต่อแล้วลองใหม่',
            { type: 'alert', color: 'error', width: 380 })
        })
      }
      else if (item.api) {
        this.$store.commit('setApi', item.api)
      }
    },
    
    getMenuItemClass(item) {
      if (item.api && item.api === this.$store.state.currentApi) {
        return 'teal--text'
      }
      return ''
    },
    
    passwordChanged() {
      this.$root.$message('เปลี่ยนรหัสผ่านแล้ว',
        'ครั้งต่อไปให้เข้าสู่ระบบด้วยรหัสผ่านใหม่',
        { type: 'alert', color: 'success', width: 380 })
    },

    async logout() {
      try {
        await auth.signOut()
        this.$store.commit('clearUser')
        sessionStorage.clear()
        // this.$router.push('/')
      } catch (error) {
        // Still signed in. Saying nothing would let the user walk away from
        // a shared shop PC believing they had logged out.
        this.$root.$message('ออกจากระบบไม่สำเร็จ',
          'กรุณาลองใหม่อีกครั้ง',
          { type: 'alert', color: 'error', width: 380 })
      }
    }
  },
  mounted() {
    this.menuRole()
  },
  watch: {
    userRole(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.menuRole()
      }
    },
    // The directory loads after the menu is first built.
    userName(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.menuRole()
      }
    }
  }
}
</script>

<style scoped>
.orange--text.text--accent-3 {
  color: #FF9800 !important;
}
.teal--text {
  color: #26A69A !important;
}

.no-uppercase {
  text-transform: none !important;
}

</style>